<template>
    <div class="list">
        <div class="list-item" v-for="index in repeat" :key="index">
            <Skeletor width="14px" class="checkbox" pill/>
            <Skeletor width="calc(100% - 19px)"  :pill="true"/>
        </div>
    </div>
</template>

<script setup>
defineProps({
    repeat: {
        type: Number,
        required: true
    }
})
</script>

<style lang="scss">
.list{
    display: flex;
    flex-direction: column;
    gap: 5px;
    &-item{
        display: flex;
        flex-direction: row;
        gap: 5px;
    }
}
</style>